import React, { Component } from 'react';
import { API_URL } from '../../apiConfig';
import UserContext from '../../UserContext';
import DefaultLayout from './layouts/Default';
import logo from './../../images/Lakovna_LOGO.png';

class Login extends Component {

    static contextType = UserContext;

    constructor(props) {
        super(props)

        this.state = {
            userName: "",
            password: "",
            error: null
        }
    }

    componentDidMount() {
        const parent = window.parent; // eslint-disable-line no-restricted-globals
        if (parent.setDemoFrameHeight) {
            parent.setDemoFrameHeight();
        }

        const { setUser } = this.context;
        setUser({ loggedIn: false });
    }

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (this.state.userName && this.state.password)
                this.onLogin();
        }
    }

    onLogin() {

        // poc/api: cookie session (BFF), ne skrineWebserver JWT — proto credentials:
        // 'include' (aby prohlížeč uložil a pak i posílal cookii nastavenou serverem)
        // a tělo/pole podle AuthController.LoginRequest(Kod, Heslo), ne UserName/Password.
        const requestOptions = {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ Kod: this.state.userName, Heslo: this.state.password })
        };

        fetch(`${API_URL}/api/auth/login`, requestOptions)
            .then(response => {
                if (response.status === 400 || response.status === 401) {
                    this.setState({
                        error: "Chybně zadané uživatelské jméno, heslo nebo nedostatečná práva pro přihlášení"
                    })
                    return null;
                }
                return response.json();
            })
            .then(response => {
                if (response) {
                    const { setUser } = this.context;

                    const canEdit = (response.prava || []).includes('LAKOVNA_EDIT');
                    const canRevert = (response.prava || []).includes('LAKOVNA_VRATIT');

                    setUser(
                        {
                            loggedIn: true,
                            userName: response.kod,
                            fullName: response.popis,
                            type: response.role,
                            canEdit: canEdit,
                            canRevert: canRevert
                        }, () => {
                            this.props.history.push('/overview');
                        });
                }
            })
            .catch(err => {
                console.log(err);
            });
    }

    render() {
        return (
            <DefaultLayout>
                <div className="row loginForm">
                    <div className="col-lg-4 col-md-2">
                    </div>
                    <div className="col-lg-4 col-md-8">
                        <div className="card loginForm-background">
                            <div className="card-body">
                                <div className="text-center px-xl-3">
                                    <p>
                                        <img
                                            src={logo}
                                            alt="Lakovna"
                                        />
                                    </p>
                                    
                                    <br />

                                    <form autoComplete="on">

                                        <div className="form-group">
                                            <div>
                                                <input
                                                    autoFocus
                                                    id="username"
                                                    name="username"
                                                    className="form-control w-100"
                                                    type="text"
                                                    value={this.state.userName}
                                                    placeholder="uživatelské jméno"
                                                    onChange={(e) => this.setState({ userName: e.target.value })}
                                                    onKeyPress={this.handleKeyPress} />
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <div>
                                                <input
                                                    id="password"
                                                    name="password"
                                                    className="form-control w-100"
                                                    type="password"
                                                    value={this.state.password}
                                                    placeholder="heslo"
                                                    onChange={(e) => this.setState({ password: e.target.value })}
                                                    onKeyPress={this.handleKeyPress} />
                                            </div>
                                        </div>

                                        <br className="my-3" />

                                        <div hidden={!this.state.error}>
                                            <h5 className="text-danger">{this.state.error}</h5>
                                            <hr className="my-3" />
                                        </div>

                                        <button
                                            className="btn btn-primary btn-block"
                                            type="button"
                                            onClick={() => this.onLogin()} disabled={!this.state.userName | !this.state.password}><i className="fa fa-sign-in"></i> Přihlášení</button>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-2">
                    </div>
                </div>
            </DefaultLayout>
        )
    }
}

export default Login

